export enum EmailTemplateEditEvents {
  EDIT_DOCUMENTS_CONTRACT_EMAIL_TEMPLATE = 'edit-documents-contract-email-template-outbound',
  EDIT_EMAIL_TEMPLATE_IN_APP = 'edit-email-template-in-app',
}
